import { MEDIA_QUERIES, BREAKPOINTS } from '../utils/breakpoints.js';

export function initSliderFunctions() {
    (() => {
        document.querySelectorAll(".js-flowSlider").forEach((el) => {
            const wrapper = el.querySelector(".modFlowSlider__inner");
            if (!wrapper) return;
    
            let rafId = null;
            let pos = 0;
            let setWidth = 0;
            const speed = 60;
            let isLooping = false;
    
            function getSetWidth(slides) {
                const gap = 20;
                let w = 0;
                slides.forEach((s) => { w += s.offsetWidth + gap; });
                return w - gap;
            }
    
            function cleanup() {
                if (rafId) {
                    cancelAnimationFrame(rafId);
                    rafId = null;
                }
                wrapper
                    .querySelectorAll(".modFlowSlider__item[data-duplicate]")
                    .forEach((s) => s.remove());
                wrapper.style.justifyContent = "";
                wrapper.style.transform = "";
                pos = 0;
                isLooping = false;
                wrapper.classList.remove("is-sliding");
            }
    
            function startAnimation() {
                wrapper.classList.add("is-sliding");
                let lastTime = performance.now();
                function animate(time) {
                    const dt = (time - lastTime) / 1000;
                    lastTime = time;
                    pos += speed * dt;
                    if (pos >= setWidth) pos -= setWidth;
                    wrapper.style.transform = "translateX(" + (-pos) + "px)";
                    rafId = requestAnimationFrame(animate);
                }
                rafId = requestAnimationFrame(animate);
            }
    
            function build() {
                cleanup();
    
                const slides = wrapper.querySelectorAll(".modFlowSlider__item");
                if (slides.length === 0) return;
    
                const containerW = el.clientWidth;
                if (containerW === 0) return;
    
                setWidth = getSetWidth(slides);
    
                if (setWidth <= containerW) {
                    wrapper.style.justifyContent = "center";
                    return;
                }
    
                isLooping = true;
                wrapper.style.justifyContent = "flex-start";
    
                const minWidth = containerW + setWidth;
                let totalW = setWidth;
    
                while (totalW < minWidth) {
                    slides.forEach((s) => {
                        const clone = s.cloneNode(true);
                        clone.setAttribute("data-duplicate", "true");
                        wrapper.appendChild(clone);
                        totalW += s.offsetWidth + 20;
                    });
                }
    
                startAnimation();
            }
    
            el.addEventListener("mouseenter", () => {
                if (rafId) {
                    cancelAnimationFrame(rafId);
                    rafId = null;
                    wrapper.classList.remove("is-sliding");
                }
            });
    
            el.addEventListener("mouseleave", () => {
                if (isLooping && !rafId) startAnimation();
            });
    
            let timer;
            let currentWindowWidth = window.innerWidth;
    
            window.addEventListener("resize", () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    if (currentWindowWidth !== window.innerWidth) {
                        currentWindowWidth = window.innerWidth;
                        build();
                    }
                }, 200);
            });
    
            build();
        });
    })();

        //profile slider
        (() => {
            const mqSpXTablet = window.matchMedia(MEDIA_QUERIES.sp_x_tablet);
    
            document.querySelectorAll(".js-profileCardSlider").forEach((el) => {
                let swiper = null;
    
                const init = () => {
                    if (swiper) return;
                    swiper = new Swiper(el, {
                        watchOverflow: true,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                        observer: true,
                        resizeObserver: true,
                        observeParents: true,
                        pagination: {
                            el: el.querySelector(".modProfileCardSlider__pagination"),
                            clickable: true,
                        },
                        breakpoints: {
                            [BREAKPOINTS.tablet_min]: {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                            },
                        },
                    });
                };
    
                const destroy = () => {
                    if (!swiper) return;
                    swiper.destroy(true, true);
                    swiper = null;
                };
    
                const update = () => {
                    if (mqSpXTablet.matches) {
                        init();
                    } else {
                        destroy();
                    }
                };
    
                update();
                mqSpXTablet.addEventListener("change", update);
            });
        })();
}